/** Supabase user id allowed to access the marketing-site CMS admin. */
export const CMS_SUPER_ADMIN_ID = '926ede11-3607-446e-a7aa-400bd22635ff';

/** Route that completes Supabase magic-link sign-in before entering the CMS. */
export const CMS_ADMIN_AUTH_CALLBACK_PATH = '/admin/auth/callback';

export function isCmsSuperAdmin(userId: string | null | undefined): boolean {
  return userId === CMS_SUPER_ADMIN_ID;
}
